import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getContractualTermPending} from '../../services/getContractualTermPending';
import {UseGetContractualTermPendingQueryParams} from './types';

export const useGetContractualTermPendingQuery = ({
	nuContrato,
	enabled = true,
}: UseGetContractualTermPendingQueryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONTRACTUAL_TERM_PENDING, nuContrato],
		queryFn: () => getContractualTermPending({nuContrato}),
		enabled: enabled && Boolean(nuContrato),
		retry: 1,
	});
